/**
 * SIDCDatawarehouse
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CreateGoodsReceiptDetailCommand { 
    goodsReceiptId?: number;
    barcode?: string;
    itemId?: number;
    itemCode?: string;
    itemDescription?: string;
    unitOfMeasureId?: number;
    unitOfMeasureCode?: string;
    unitOfMeasureDescription?: string;
    quantity?: number;
    remaining?: number;
    price?: number;
    total?: number;
    conversion?: number;
    warehouseId?: number;
    warehouseCode?: string;
    systemDate?: Date;
    idUser?: string;
    runningQuantity?: number;
    averageCost?: number;
    runningValue?: number;
}